import {useContext, useEffect, useRef, useState} from "react";
import LoadingScreen from "./LoadingScreen";
import Spinner from "./Spinner";
import BottomButtonWrapper from "./BottomButtonWrapper";
import Button from "./Button";
import Api from "../tools/service";
import Swal from "sweetalert2";
import AppContext from "../tools/contexts/AppContext";
import AuthContext from "../tools/contexts/AuthContext";

const BugModal=({data,type,onClose,accessToken,priority})=>{

    const appContext=useContext(AppContext)
    const authContext=useContext(AuthContext)
    const [messages,setMessages]=useState(null);
    const [isLoading,setLoading]=useState(true);
    const [selectedItem,setSelected]=useState(null);
    const [description,setDescription]=useState('');
    const [preDescription,setPreDescription]=useState('');
    const [isDisabled,setDisabled]=useState(true);
    const [isTextAreaDisabled,setIsTextAreaDisabled]=useState(true);
    const textareaRef=useRef(null);
    const handleClick=(index,text)=>{
        setSelected(index);
        if(index!='custom'){
            setPreDescription(text)
            setDisabled(false)
            setDescription(text+' ')
        }else {
            setDisabled(true)
            setPreDescription('سایر')
            setDescription(text+' ')
        }
        setIsTextAreaDisabled(false);
        textareaRef.current.focus()

    }
    useEffect(()=>{
       data.services.forEach((item)=>{
            if(item.name===type){
                setMessages(item.messages);
                setLoading(false)
            }
       })
    },[]);
    const onDescriptionChange=(e)=>{
            setDescription(e.target.value)
        if(e.target.value.length>=3&&e.target.value.length<=100){

            setDisabled(false)
        }else {

            setDisabled(true)
        }

    }
    const handleReport=()=>{
            const data={
                "service_type":type,
                "priority":priority || "medium",
                "pre_description":preDescription,
                "description":description.length>0 ? description :description,
                "pid":localStorage.getItem('pid')
            }

        appContext.handleLoading(true)
        Api.post('/api/v1/Providers/Reports/Create',data,{
            headers:{
                "Authorization": `Bearer ${accessToken?accessToken:authContext.user.personal_token}`
            }
        }).then(response=>{

            if(!response.hasError){
                Swal.fire({
                    allowOutsideClick:false,
                    text: response.message,
                    title: "موفق",
                    icon: 'success',
                    showCancelButton: false,
                    confirmButtonColor: '#419e53',
                    confirmButtonText:'بستن',

                }).then((result)=>{
                    if(result.isConfirmed){
                       onClose()
                    }
                })
            }else {
                Swal.fire({
                    allowOutsideClick:true,
                    text: response.message,
                    title: "ناموفق",
                    icon: 'error',
                    showCancelButton: false,
                    showCloseButton:true,
                    confirmButtonColor: '#d51e3e',
                    confirmButtonText:'تلاش مجدد',


                }).then((result)=>{
                    if(result.isConfirmed){
                        handleReport()
                    }else {

                    }
                })
            }
        }).catch(e=>{

        }).finally(()=>{
            appContext.handleLoading(false)
        })

    }
    if(isLoading){
       return <div><Spinner/></div>
    }
    return  <div className="w-full z-50 fixed pt-8 flex pb-24 items-center flex-col overflow-scroll  h-screen top-0 left bg-gray-100">
            <div className="w-11/12  md:w-8/12 lg:w-6/12">
                <div className="flex flex-col pb-5 border-b mb-5  items-center justify-center">
                    <h1 className="text-xl font-bold mb-1 ">گزارش خطا</h1>
                    <p className=" text-center">در صورتی که با مشکلی رو به رو شدید می‌توانید از طریق فرم زیر مشکل را گزارش دهید.</p>
                </div>
                <div className="grid grid-cols-1 w-full gap-2 ">
                    {messages.length>0  && messages.map((item,index)=>{

                        return   <div onClick={()=>{handleClick(index,item.text)}} className={`border rounded-lg   items-center flex justify-between  p-2 py-5  ${selectedItem===index ? 'bg-red-100 border-2 border-red-400 text-red-600':'bg-white'}`} key={index}>
                            <span>{item.text}</span>
                            <div className={`${selectedItem!==index ? 'bg-gray-100 border':'bg-red-500'} rounded-full w-4 h-4  `}></div>
                        </div>


                    })}
                    <div onClick={()=>{handleClick('custom','')}} className={`border rounded-lg   items-center flex justify-between  p-2 py-5  ${selectedItem==='custom' ? 'bg-red-100 border-2 border-red-400 text-red-600':'bg-white'}`} key={'custom'}>
                        <span>سایر</span>
                        <div className={`${selectedItem!=='custom' ? 'bg-gray-100 border':'bg-red-500'} rounded-full w-4 h-4  `}></div>
                    </div>


                    {<div className="w-full">
                        <span className="">توضیحات </span>
                        <textarea ref={textareaRef} disabled={isTextAreaDisabled} onChange={onDescriptionChange} value={description} className={`bg-white w-full   p-3 outline-none rounded-lg ${isTextAreaDisabled && 'bg-opacity-50 cursor-not-allowed'}`} minLength={5} maxLength={200} name="" id="" placeholder="توضیحات را وارد کنید." cols="30" rows="3"></textarea>
                    </div>}

                </div>
            </div>
            <BottomButtonWrapper grid={2}>
                <Button theme="link"  onClick={onClose} rounded="rounded-xl" className="">بستن</Button>
                <Button theme="red" disabled={isDisabled} onClick={handleReport} rounded="rounded-xl" className="">ارسال گزارش</Button>

            </BottomButtonWrapper>
             </div>
}
export default BugModal;